export var MessageType;
(function (MessageType) {
    MessageType[MessageType["INCOMING"] = 0] = "INCOMING";
    MessageType[MessageType["OUTGOING"] = 1] = "OUTGOING";
    MessageType[MessageType["ACTIVITY"] = 2] = "ACTIVITY";
    MessageType[MessageType["TEMPLATE"] = 3] = "TEMPLATE";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=message.js.map